import axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import Ledger from "../../Components/ReportTables/Ledger";
import { Client_Search } from "../../Configuration/API_URL";
import $ from "jquery";
import { AESEncryption, ApiResDecrypt, checkDateRange, compareDate } from "../../CommonMethhods/CommonMethods";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import { Constants } from "../../CommonMethhods/Constants";
import TodateComponent from "./TodateComponent";
import FromdateComponent from "./FromdateComponent";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import DurationChangeComponent from "./DurationChangeComponent";
import { useDebounce } from "../../Components/useDebounce";

function LedgerReportSidebar(props) {
    const storeToken = localStorage.getItem("ssoToken");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [gridVal, setGridVal] = useState("");
    const [loader, setLoader] = useState(false);
    const [checkDate, setCheckDate] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [smallLoaderMail, setSmallLoaderMail] = useState(false);
    const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
    const [clientNameError, setClientNameError] = useState(false);
    const [errorResp, setErrorResp] = useState("");
    const [nameError, setNameError] = useState("");
    const [page, setPage] = useState(1);
    const [scrollLoader, setScrollLoader] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [scroll, setScroll] = useState(false);
    const [clientName, setClientName] = useState("");
    const [clientCode, setClientCode] = useState("");
    const [serverError, setServerError] = useState("");
    const [customShow, setCustomShow] = useState(false);
    const [selectDuration, setSelectDuration] = useState("");
    const [isSelectingClient, setIsSelectingClient] = useState(false);

    const debouncedValue = useDebounce(clientCode, 1000);
    useEffect(() => {
        if (isSelectingClient) {
            setIsSelectingClient(false);
            return;
        }
        handleClientName(debouncedValue);
    }, [debouncedValue]);

    if (fromDate == "" || toDate == "") {
        const current = new Date();
        const CurrentYear = current.getFullYear();
        const CurrentMonth = current.getMonth();
        if (CurrentMonth < 4) {
            const newYear = `04-01-${CurrentYear - 1}`;
            const date = `${current.getMonth() + 1}-${current.getDate()}-${current.getFullYear()}`;
            const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
            setFromDate(newYear);
            setToDate(date1);
        } else {
            const newYear = `04-01-${CurrentYear}`;
            const date = `${current.getMonth() + 1}-${current.getDate()}-${current.getFullYear()}`;
            const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
            setFromDate(newYear);
            setToDate(date1);
        }
    }

    async function searchApiDetail(e) {
        $(".write-search.ledger").addClass("show-result scroll-table");
        let payloadValue = {
            keyword: e.toUpperCase(),
            Status: "",
            PageNo: page,
            PageSize: 10,
        };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getSearchDetail = await axios.post(
                Client_Search.Search_URL,

                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                },
            );

            const res = ApiResDecrypt(getSearchDetail?.data);

            if (res.message === "Client does not exist.") {
                setClientList([{ clientname: "Client does not exist.", clientCode: null }]);
            } else {
                if (scroll == true) {
                    setClientList((prev) => {
                        return [...prev, ...res.data.clients];
                    });
                    setServerError("");
                } else {
                    setClientList(res.data.clients);
                    setServerError("");
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setScrollLoader(false);
        }
    }

    function clientSet(name, code, i) {
        if (name === "Client does not exist.") {
            $(".write-search.ledger").addClass("show-result scroll-table");
        } else {
            $(".write-search.ledger").removeClass("show-result");
            setClientList([]);
            setIsSelectingClient(true);
            setClientName(name);
            setClientCode(code);
            setScrollLoader(false);
        }
    }

    const handleClientName = (data) => {
        setScrollLoader(false);
        setGridVal("");
        // setFileType("");
        setNameError("");
        if (data) {
            setClientList([]);
            setScroll(false);
            // let result = data.toUpperCase();
            // setClientName(result);
            if (data?.length > 2) {
                setPage(1);
                setScrollLoader(true);
                setClientList([]);
                setScroll(false);
                searchApiDetail(data);
            }
        } else {
            setClientList([]);
            setPage(1);
            setClientName("");
            setScroll(false);
            $(".write-search.ledger").removeClass("show-result");
        }
        $(".write-search.ledger-li").click(function () {
            $(".write-search.ledger").addClass("show-result scroll-table");
        });
    };

    const handleScroll = async () => {
        if (isSelectingClient) return;
        setScroll(true);
        const a = document.querySelector("#ledger-scroll");
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
            setPage((prev) => prev + 1);
            setScrollLoader(true);
            searchApiDetail(clientName);
        }
    };

    const getLedgerReport = async (fileType) => {
        setLoader(true);
        if (fileType == "excel") {
            setSmallLoaderExcel(true);
            setSmallLoaderPdf(false);
            setSmallLoaderMail(false);
            setLoader(false);
        } else if (fileType == "pdf") {
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(true);
            setSmallLoaderMail(false);
            setLoader(false);
        } else if (fileType == "mail") {
            setSmallLoaderMail(true);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
            setLoader(false);
        } else {
            setSmallLoaderMail(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
        }
        let payloadValue = {
            clientCode: clientCode,
            fromDate: fromDate,
            toDate: toDate,
            fileType: fileType,
            seg: "stocks",
        };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axios.post(
                Dashboard_Client_Report.LedgerReport_URL,

                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                },
            );
            const res = ApiResDecrypt(getDetails?.data);
            if (res?.data) {
                if (fileType == "grid") {
                    setGridVal(res?.data.ledger);
                } else if (fileType == "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                } else if (fileType == "pdf") {
                    window.open(res?.data, "_blank", "noopener,noreferrer");
                } else {
                    toast.success("Mail sent successfully");
                }
            } else {
                setGridVal([]);
                if (fileType == "excel") {
                    toast.error("Ledger Report does not exist.");
                } else if (fileType == "pdf") {
                    toast.error("Ledger Report does not exist.");
                } else if (fileType == "mail") {
                    toast.error("Ledger Report does not exist.");
                }
            }
            setClientNameError(false);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
            setSmallLoaderPdf(false);
            setSmallLoaderMail(false);
        } catch (error) {
            console.log(error);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
            setSmallLoaderMail(false);
            setLoader(false);
            setServerError("Something went wrong, Please try again later.");
            if (fileType == "excel") {
                toast.error("Something went wrong, Please try again later.");
            }
            if (fileType == "pdf") {
                toast.error("Something went wrong, Please try again later.");
            }
            if (fileType == "mail") {
                toast.error("Something went wrong, Please try again later.");
            }
        }
    };

    const handleFromDateChange = (e) => {
        setGridVal("");
        // setFileType("");
        let c = e.target.value;
        const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
        setFromDate(d);
        setErrorResp("");
        setServerError("");
    };
    const handleToDateChange = (e) => {
        setGridVal("");
        // setFileType("");
        let c = e.target.value;
        const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
        setToDate(d);
        setErrorResp("");
        setServerError("");
    };

    function clientSet(name, code, i) {
        if (name === "Client does not exist.") {
            $(".write-search.ledger").addClass("show-result scroll-table");
        } else {
            $(".write-search.ledger").removeClass("show-result");
            setClientList([]);
            setIsSelectingClient(true);
            setClientName(name);
            setClientCode(code);
        }
    }

    // useEffect(() => {
    //   if (fileType != "") {
    //     getLedgerReport();
    //   }
    // }, [fileType]);

    function formatDate(date) {
        return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }

    const handleOnClick = (e) => {
        if (clientName.length > 0) {
            setClientNameError(false);
            if (e.target.value) {
                if (selectDuration) {
                    if (compareDate(fromDate) && compareDate(toDate) && checkDateRange(fromDate, toDate)) {
                        getLedgerReport(e.target.value);
                        setErrorResp("");
                    } else {
                        setCheckDate(true);
                        setErrorResp("Please Select Correct Date");
                    }
                } else {
                    setErrorResp("Please Select Duration");
                }
            }
        } else {
            setClientNameError(true);
            setNameError("Please Enter Client Name/Code");
        }
    };

    const colourStyles = {
        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            background: isFocused ? "#007bff" : isSelected ? "#007bff" : "#fff",
            color: isSelected ? "white" : isFocused ? "white" : "gray",
        }),
    };

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");

    const onChangeDuration = () => {
        setGridVal("");
        setErrorResp(false);
        setServerError(false);
    };
    return (
        <>
            <Header portal={"RM"} />
            {/* <Sidebar /> */}
            <SingleSignOnSideBar />
            <main id="main-content" className="reports">
                <div className="card-box">
                    <div>
                        <h2 className="report-title">{Constants.Financial_Ledger_Report}</h2>
                    </div>
                    <div className="row input-field-wrapper">
                        <div className="col-md-3 col-sm-3 col-12">
                            <div className="form-group">
                                <label className="form-label">{Constants.Client_Name}</label>
                                <div className="input-text-wrapper align-items-center">
                                    <input
                                        id="input1"
                                        type="text"
                                        className="input-text form-control"
                                        placeholder="Search by Name/ Code"
                                        value={clientName}
                                        onChange={(e) => {
                                            setClientCode(e.target.value.toUpperCase());
                                            setClientName(e?.target?.value?.toUpperCase());
                                            // handleClientName(e);
                                        }}
                                        onInput={(e) => {
                                            const start = e.target.selectionStart;
                                            const end = e.target.selectionEnd;
                                            let input = e.target.value;
                                            input = input
                                                .toUpperCase()
                                                .replace(/[^A-Z0-9\s]/g, "")
                                                .replace(/\s+/g, " ")
                                                .trimStart()
                                                .slice(0, 100);

                                            e.target.value = input;
                                            e.target.setSelectionRange(start, end);
                                        }}
                                    />
                                    <ul
                                        className="write-search ledger border-0"
                                        id="ledger-scroll"
                                        onScroll={handleScroll}
                                    >
                                        {clientList.map((item, i) => (
                                            <li key={i} onClick={() => clientSet(item.clientname, item.clientCode, i)}>
                                                <div> {item.clientname}</div>
                                                <div> {item.clientCode}</div>
                                            </li>
                                        ))}
                                        {scrollLoader && (
                                            <div className="loader-center">
                                                <LoaderForSearch />
                                            </div>
                                        )}
                                    </ul>
                                </div>
                                <span className="to-date-error">{nameError}</span>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-6">
                            <div className="form-group">
                                <DurationChangeComponent
                                    setCustomShow={setCustomShow}
                                    setFromDate={setFromDate}
                                    setToDate={setToDate}
                                    onChangeDuration={onChangeDuration}
                                    setSelectDuration={setSelectDuration}
                                    selectDuration={selectDuration}
                                    showOptionCustom={false}
                                    showOnlyFY={false}

                                />
                            </div>
                            {errorResp && !selectDuration && <span className="duration-date-error">{errorResp}</span>}
                        </div>

                        {customShow && (
                            <div className="col-md-3 col-sm-3 col-12">
                                <FromdateComponent
                                    fromDate={handleFromDateChange}
                                    formatDate={formatDate(fromDate)}
                                    DateReverse={DateReverse}
                                    clientWiseReportForCustomCalanderIcon={true}
                                />
                            </div>
                        )}
                        {customShow && (
                            <div className="col-md-3 col-sm-3 col-12">
                                <TodateComponent
                                    toDate={handleToDateChange}
                                    formatToDate={formatDate(toDate)}
                                    DateReverse={DateReverse}
                                    errorResponse={errorResp}
                                    clientWiseReportForCustomCalanderIcon={true}
                                />
                            </div>
                        )}
                    </div>
                    <div className="text-center search-btn-wrapper">
                        <button value="grid" className="send-message" onClick={handleOnClick}>
                            {Constants.Search}
                        </button>
                    </div>
                    <div>
                        <ReportTableHeader
                            smallLoaderMail={smallLoaderMail}
                            showEmailBtn={true}
                            handleOnClick={handleOnClick}
                            smallLoaderExcel={smallLoaderExcel}
                            smallLoaderPdf={smallLoaderPdf}
                        />
                    </div>
                    <div className="for-grid-section">
                        {loader ? (
                            <div className="loader-alignment">
                                <Loader />
                            </div>
                        ) : gridVal ? (
                            <div>
                                <Ledger gridVal={gridVal} />
                            </div>
                        ) : serverError === "Something went wrong, Please try again later." ? (
                            <h4 className="report-error-message">{serverError}</h4>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </main>
        </>
    );
}
export default LedgerReportSidebar;
